import React, { useState } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import { getCountry } from "Listfunction";
import { useEffect } from "react";

const Country = (props) => {
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;

  const [countries, setCountries] = useState();
  const [isLoading, setIsLoading] = useState(true);
  console.log(countries);
  useEffect(() => {
    getCountry(obj).then((res) => {
      setCountries(res.data);
      localStorage.setItem("existingCountries", JSON.stringify(res.data));
      setIsLoading(false);
    });
  }, []);

  return (
    <div className="main-content">
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Card
              tableFullWidth
              content={
                <Row>
                  <Col md={12} sm={12} lg={12} xs={12}>
                    <Col md={12} sm={12} lg={12} xs={12} className="text-right">
                      <Button
                        className="w_user btn-fill fl_mb_1 fl_mb_web_1"
                        fill
                        style={{ backgroundColor: "#2b3a41" }}
                        onClick={() =>
                          props.history.push("/admin/add-country")
                        }>
                        Add Country <i className="fa fa-plus"></i>
                      </Button>
                      &nbsp;
                    </Col>
                  </Col>

                  <Col md={12} sm={12} lg={12} xs={12}>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Country Name</th>
                          <th>Country Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td colspan="10">
                              <LoadingSpinner />
                            </td>
                          </tr>
                        ) : countries ? (
                          <React.Fragment>
                            {countries.map((country) => {
                              return (
                                <tr key={country.id}>
                                  <td>{country.country_name}</td>
                                  <td>{country.country_code}</td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ) : (
                          <tr>
                            <td colspan="10">
                              <center>No record found</center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default Country;
